// extracted by css-extract-rspack-plugin
export default {"cls1":"OnboardingTour-cls1_hXi","cls2":"OnboardingTour-cls2_HPt OnboardingTour-cls1_hXi"};